import { setWrapScrollFadeClasses, clearWrapScrollFadeClasses } from './horizontal-scroll-edge.js';

const START_CLASS = 'settings-nav-wrap--scroll-start';
const END_CLASS = 'settings-nav-wrap--scroll-end';
const cleanupByWrap = new WeakMap();

export function markSettingsNavActive(link) {
    const nav = link ? link.closest('.settings-nav-wrap') : null;
    if (!nav) {
        return;
    }

    nav.querySelectorAll('.settings-nav-link, .settings-nav-tab, .whats-new-nav__link').forEach(function (item) {
        item.classList.remove('active');
    });
    link.classList.add('active');

    if (link.classList.contains('settings-nav-link')) {
        link.classList.add('loading');
    }
}

export function updateSettingsNavScrollFades(wrap) {
    const scroller = wrap.querySelector('.settings-nav-scroll');
    if (!scroller) {
        return;
    }
    setWrapScrollFadeClasses(scroller, wrap, START_CLASS, END_CLASS);
}

export function unbindSettingsNavScrollFades(wrap) {
    const cleanup = cleanupByWrap.get(wrap);
    if (cleanup) {
        cleanup();
    }
    cleanupByWrap.delete(wrap);
    clearWrapScrollFadeClasses(wrap, START_CLASS, END_CLASS);
}

function bindSettingsNavScrollFades(wrap) {
    unbindSettingsNavScrollFades(wrap);
    const scroller = wrap.querySelector('.settings-nav-scroll');
    if (!scroller) {
        return;
    }

    const onChange = function () {
        updateSettingsNavScrollFades(wrap);
    };
    scroller.addEventListener('scroll', onChange, { passive: true });
    window.addEventListener('resize', onChange);
    let resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(onChange);
        resizeObserver.observe(scroller);
    }

    cleanupByWrap.set(wrap, function () {
        scroller.removeEventListener('scroll', onChange);
        window.removeEventListener('resize', onChange);
        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    });

    onChange();
    window.setTimeout(onChange, 0);
}

export function scrollSettingsNavActiveIntoView(wrap) {
    const scroller = wrap.querySelector('.settings-nav-scroll');
    const active = wrap.querySelector('.settings-nav-tab.active');
    if (!scroller || !active) {
        return;
    }

    const scrollerWidth = scroller.clientWidth;
    const maxScroll = scroller.scrollWidth - scrollerWidth;
    const scrollerRect = scroller.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const activeOffset = (activeRect.left - scrollerRect.left) + scroller.scrollLeft;
    const targetScroll = activeOffset - ((scrollerWidth - activeRect.width) / 2);
    scroller.scrollLeft = Math.max(0, Math.min(maxScroll, targetScroll));
}

export function initSettingsNavScroll(root) {
    if (!root) {
        return;
    }

    root.querySelectorAll('.settings-nav-wrap').forEach(function (wrap) {
        if (!cleanupByWrap.has(wrap)) {
            bindSettingsNavScrollFades(wrap);
        }
        scrollSettingsNavActiveIntoView(wrap);
        updateSettingsNavScrollFades(wrap);
    });
}
